const NumericRuleCard = (props) => {
    const { step, decision, limiter, description } = props
    return (
        <div className="inbox__cell--left" style={{ paddingBottom: "10px" }}>
            <p className="data-field dialogTitle" style={{ marginBottom: "8px" }}>
                <span className="data-field__label">
                    <b>
                        {step}
                    </b>
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Decisão:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {decision}
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Limitador:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {limiter}
                </span>
            </p>
            <p>
                <span className="data-field__label">
                    Descrição:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {description}
                </span>
            </p>
        </div>
    )
}

export default NumericRuleCard